<template>
  <fragment>
    <PlayerInfo
      v-if="!this.error"
      v-bind:player="this.player"
      v-bind:loading="this.loading"
    />
    <EloProgress
      v-bind:playerInfo="this.player.player_info.games.csgo"
      v-bind:loading="this.loading"
      v-if="!this.error"
    />
    <MatchHistory
      v-if="!this.error"
      v-bind:player_id="this.player.profile_info.player_id"
    />
    <chicken404 v-if="this.error" :error="this.error" />
  </fragment>
</template>

<script>
import axios from "axios";

import PlayerInfo from "../components/PlayerInfo.vue";
import EloProgress from "../components/EloProgress.vue";
import MatchHistory from "../components/MatchHistory.vue";
import Chicken404 from "../components/Chicken404.vue";

export default {
  name: "PlayerFetched",
  components: {
    PlayerInfo,
    EloProgress,
    MatchHistory,
    Chicken404
  },
  data() {
    return {
      componentKey: 0,
      loading: false,
      nickname: this.$route.params.nickname,
      player: {
        profile_info: {},
        player_info: {},
        player_stats: {}
      },
      error: ""
    };
  },
  async created() {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_BEARER_KEY}`
      }
    };
    this.loading = true;
    try {
      const res = await axios.get(
        `https://open.faceit.com/data/v4/search/players?nickname=${this.$route.params.nickname}&game=csgo&offset=0&limit=1`,
        config
      );
      if (res.data.items.length > 0) {
        this.player.profile_info = res.data.items[0];
        try {
          const res = await axios.get(
            `https://open.faceit.com/data/v4/players/${this.player.profile_info.player_id}`,
            config
          );
          this.player.player_info = res.data;
        } catch (err) {
          this.error = "Wystąpił błąd z pobraniem danych z bazy Faceita.";
          this.error = "Wystąpił błąd.";
        }
        try {
          const res = await axios.get(
            `https://open.faceit.com/data/v4/players/${this.player.profile_info.player_id}/stats/csgo`,
            config
          );
          this.player.player_stats = res.data.lifetime;
        } catch (err) {
          this.error = "Wystąpił błąd z pobraniem danych z bazy Faceita.";
        }
      } else {
        this.error = "Nie istnieje gracz o takim nicku.";
        this.$toast.error("Nie istnieje gracz o takim nicku.", {
          position: "top-left",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          hideCloseButton: false,
          hideProgressBar: false,
          icon: true
        });
      }
    } catch (err) {
      this.error = "Wystąpił błąd z pobraniem danych z bazy Faceita.";
    }
    this.loading = false;
  }
};
</script>
